import BsPagination from "./BsPagination";

export default Vue => {
    Vue.component(BsPagination.name, BsPagination);
};
